/* Core */
import { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext();

const ThemeProvider = ({ children }) => {
	if (!('theme' in localStorage)) {
		if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
			localStorage.theme = 'dark';
		} else {
			localStorage.theme = 'light';
		}
	}

	const [theme, setTheme] = useState(localStorage.theme);

	useEffect(() => {
		document.documentElement.classList.remove(
			theme === 'dark' ? 'light' : 'dark',
		);
		document.documentElement.classList.add(theme);
	}, [theme]);

	const handleTheme = (value) => {
		setTheme(value);
		localStorage.theme = value;
	};

	const value = { theme, setTheme: handleTheme };

	return (
		<ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
	);
};

const useTheme = () => {
	const theme = useContext(ThemeContext);

	if (theme === undefined) {
		throw new Error('useTheme must be used within a ThemeProvider');
	}

	return theme;
};

export { ThemeProvider, useTheme };
